import { SwanStyleSheetKey } from '@vp/swan'

export const SWAN_STYLE_KEYS: SwanStyleSheetKey[] = [
  'core',
  'accordion',
  'alertBox',
  'button',
  'carousel',
  'grid',
  'hidden',
  'icon',
  'listbox',
  'modalDialog',
  'pagination',
  'progressiveImage',
  'selectionSet',
  'standardTile',
  'toggleSwitch',
  'ratingsStars',
  'progressBar',
  'utility',
  'visible',
  'spinner',
  'pricing',
  'baseTile',
  'emptyState',
  'popover',
]
